import { APPROUTES } from "./app.routes.strings";
import { NavItem } from "./infrastructure/sidenav/nav-item";

export const NavItems: NavItem[] = [
  {
    icon: "home",
    text: "nav.home",
    routerLink: APPROUTES.home,
    exact: true,
    requiresAuthorization: false,
  },
  {
    icon: "person",
    text: "nav.profile",
    routerLink: APPROUTES.users.details,
    exact: false,
    requiresAuthorization: true,
  },
  {
    icon: "work",
    text: "nav.organization",
    routerLink: APPROUTES.organization.base,
    exact: false,
    requiresAuthorization: true,
  },
  {
    icon: "navigation",
    text: "nav.shipments",
    routerLink: APPROUTES.shipments,
    exact: false,
    requiresAuthorization: true,
  },
];
